import React, { useCallback } from 'react';
import { batch } from 'react-redux';
import { Modal } from '@vectord/components';

import {
  bulkUpdateSyncConfirmModalStateSelector,
  setBulkUpdateSyncConfirmModalState,
  setBulkUpdateSyncType,
} from 'features/classCreation';
import BulkUpdateSyncConfirmButton from '../BulkUpdateSyncConfirmButton';
import styles from './BulkUpdateSyncConfirmModal.module.scss';
import useAppDispatch from 'hooks/useAppDispatch';
import useAppSelector from 'hooks/useAppSelector';

export default function BulkUpdateSyncConfirmModal({
  academyTopic,
}: IBulkUpdateSyncConfirmModal) {
  const dispatch = useAppDispatch();
  const isModalOpen = useAppSelector(bulkUpdateSyncConfirmModalStateSelector);

  const handleModalClose = useCallback(() => {
    batch(() => {
      dispatch(setBulkUpdateSyncType(null));
      dispatch(setBulkUpdateSyncConfirmModalState(false));
    });
  }, [dispatch]);

  return (
    <Modal
      isOpen={isModalOpen}
      unMountOnClose
      title="Sync Updates?"
      onClose={handleModalClose}
    >
      <div className={styles.root}>
        <div>
          Are you sure you want to sync updates you made in the template? This
          will reflect in the scheduled classes
        </div>
        <BulkUpdateSyncConfirmButton
          academyTopic={academyTopic}
          handleClose={handleModalClose}
        />
      </div>
    </Modal>
  );
}
